<template>
  <div class="es-form-section" :style="[padding, margin]">
    <slot name="es-form-header"></slot>
    <slot name="es-form"></slot>
  </div>
</template>

<script>
export default {
  props: {
    padding: {
      type: Object,
      default: () => ({ padding: '1.15rem' }),
    },
    margin: {
      type: Object,
      default: () => ({ margin: '0rem 4rem 0rem 1rem' }),
    },
  },
  data() {
    return {
    };
  },
};
</script>

<style lang="sass" scoped>
  .title
    text-align: left
    margin-bottom: 0
    height: 100%
    display: contents
  .es-form
    padding-top: .5rem
  .es-form-header
    font-weight: 700
    color: #212529
    text-align: left
    padding-bottom: 0.5rem
  .fields-container
    margin-left: 2.5rem
  .header-container
    display: flex
    margin-left: -1rem
    .header-elements
      margin-right: 1rem
      display: table-cell
      svg
        width: 30px
    .header-actions
      margin-left: auto
  .table
    margin-left: 2rem
    margin-right: 5rem
    .form-label
      width: 20%
    td
      padding-left: 0
      padding-right: 0

  .columns
    margin: 0
    padding-left: 2rem
    .column
      padding: 0
  .row
    min-height: 3rem
    border-bottom: 1px solid #eee
    padding-top: .5rem
    position: relative
    &.has-help
      height: auto
    margin-left: 30px
  /deep/ .label
    margin-bottom: 0
    display: flex
    align-items: center
    font-weight: 400
    font-size: .85rem
    color: #000
    min-width: 115px
  .removeUnderline
    border-bottom: 1px solid transparent !important
  .input
    padding-left: 7.75px
  select
    padding-top: 3px
</style>
